var map = {
	"./SceneActionButton.vue": 6279,
	"./SceneCharacterSpeaking.vue": 2522,
	"./SceneCredits.vue": 2292,
	"./SceneDisplayEvidencesInline.vue": 3508,
	"./SceneDynamicRankings.vue": 6920,
	"./SceneHorizontalImagesToAlign.vue": 1004,
	"./SceneImage.vue": 4613,
	"./SceneImageChoice.vue": 6927,
	"./SceneImageToTap.vue": 8422,
	"./SceneImageToTapWithChoices.vue": 2699,
	"./SceneImageWithMultipleTaps.vue": 5073,
	"./SceneImageWithSoundsToReproduce.vue": 1476,
	"./SceneImagesChoiceOnImage.vue": 8244,
	"./SceneImagesToLegend.vue": 4654,
	"./SceneInputsOnImage.vue": 47,
	"./SceneJumpDetector.vue": 8765,
	"./SceneLargeTextInput.vue": 7683,
	"./SceneLayeredPuzzle.vue": 352,
	"./SceneListOfActions.vue": 1115,
	"./SceneLocate.vue": 8440,
	"./SceneLocateByDistance.vue": 9271,
	"./SceneMap.vue": 5549,
	"./SceneNoteBook.vue": 7337,
	"./SceneNumberInput.vue": 4780,
	"./ScenePhoneCall.vue": 4456,
	"./ScenePlaySound.vue": 9976,
	"./ScenePullAnimation.vue": 927,
	"./ScenePuzzleRotate.vue": 5924,
	"./SceneQrCode.vue": 5667,
	"./SceneRankings.vue": 8915,
	"./SceneRawHeader.vue": 1992,
	"./SceneRawText.vue": 2046,
	"./SceneRichText.vue": 7003,
	"./SceneRotateAnimation.vue": 2875,
	"./SceneSayHi.vue": 6202,
	"./SceneSayHiBasic.vue": 2846,
	"./SceneScoreDetails.vue": 4981,
	"./SceneSelfie.vue": 3564,
	"./SceneShakingDetector.vue": 991,
	"./SceneTextInput.vue": 7643,
	"./SceneUniqueChoice.vue": 949,
	"./SceneUniqueChoiceImage.vue": 403,
	"./SceneYoutubeVideo.vue": 5359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5974;